import { ApolloClient } from '@apollo/client';
import { CookieHeadersQuery } from '@catalogo/core-types';
import { NormalizedCacheObject } from '@apollo/client/cache';
import cookieHeadersQuery from './cookie-headers.graphql';

export const getCookies = (client: ApolloClient<NormalizedCacheObject>) => {
  const cq = client.readQuery<CookieHeadersQuery>({
    query: cookieHeadersQuery,
  });

  return cq?.cookies;
};
